(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-core-wager/assets/javascripts/utils/conditionals.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-core-wager/assets/javascripts/utils/conditionals.js');

'use strict';

function isProlongable(wager) {
  var _wager$descriptionIte;
  if (wager.isSubscription) return false;
  if (wager.isFraction) return false;
  if (wager.isUserBoards) return false;
  if (wager.isGroup) return false;
  if (wager.isSystemWager && ((_wager$descriptionIte = wager.descriptionItems) === null || _wager$descriptionIte === void 0 ? void 0 : _wager$descriptionIte.length) > 1) return false;
  return wager.completedDrawCount === wager.totalDrawCount;
}
svs.numbergames.mybets_core_wager.utils.conditionals = {
  isProlongable
};

 })(window);